import jwtInterceptor from "@/shared/jwtInterceptor";

const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class ProductApi
{
  static async getProductCategoryForSelectAjax(str)
  {
    let url = apiUrl + 'admin/productCategory/getForSelectWithGuild';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getNoChildForSelectWithGuild(str)
  {
    let url = apiUrl + 'admin/productCategory/getNoChildForSelectWithGuild';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getGuildForSelectAjax(str)
  {
    let url = apiUrl + 'admin/Guild/getForSelectAjax';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getAllUsersForSelect(str)
  {
    let url = apiUrl + 'admin/user/getAllUserForSelect';
    if (str)
      url += '?q='+str;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCategoryInfoForEdit(id)
  {
    let url = apiUrl + 'admin/ProductCategory/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getProductInfoForEdit(id)
  {
    let url = apiUrl + 'admin/Product/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCategoryAttributes(id)
  {
    const url = apiUrl + 'admin/productCategory/getCategoryAttributeForProductPics/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCategoryAttributeForAddProduct(id)
  {
    const url = apiUrl + 'admin/productCategory/getCategoryAttributeForAddProduct/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async addProduct(product)
  {
    const url = apiUrl + 'admin/Product/Add';
    const response = await jwtInterceptor.post(url,product);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async editProduct(product)
  {
    const url = apiUrl + 'admin/Product/edit/'+product._id;
    const response = await jwtInterceptor.post(url,product);
    if (response && response.data)
    {
      return response.data
    }
  }
}